import triggerCustomGaEvent from '../analytics/triggerCustomGaEvent'

export default function tripTeaseHotelSearch(currentProperty, availability) {
	let ttHotelName = null,
			ttHotelIdentifier = null,
			ttHotelBrand = null,
			ttHotelStreetAddress = null,
			ttHotelCity = null,
			ttHotelRegion = null,
			ttHotelPostal = null,
			ttHotelCountry = null,
			ttHotelPhone = null,
			ttHotelLogo = null,
			ttHotelWebsite = null

	if (
		availability &&
		availability.basicPropertyInfo
	) {
		const crsProperty = availability.basicPropertyInfo

		if (crsProperty.hotelName) {
			ttHotelName = crsProperty.hotelName
		}

		if (
			crsProperty.viewExtensions &&
			crsProperty.viewExtensions.tripTeaseIdentifier &&
			crsProperty.viewExtensions.tripTeaseIdentifier !== ''
		) {
			ttHotelIdentifier = crsProperty.viewExtensions.tripTeaseIdentifier
		}

		if (crsProperty.brandName) {
			ttHotelBrand = crsProperty.brandName
		}

		if (crsProperty.address) {
			if (
				crsProperty.address.addressLine &&
				crsProperty.address.addressLine[0]
			) {
				ttHotelStreetAddress = crsProperty.address.addressLine[0]
			}

			if (crsProperty.address.cityName) {
				ttHotelCity = crsProperty.address.cityName
			}

			if (crsProperty.address.stateProv) {
				ttHotelRegion = crsProperty.address.stateProv
			}

			if (crsProperty.address.postalCode) {
				ttHotelPostal = crsProperty.address.postalCode
			}

			if (crsProperty.address.countryName) {
				ttHotelCountry = crsProperty.address.countryName
			}
		}

		if (
			crsProperty.contactNumbers &&
			crsProperty.contactNumbers[0] &&
			crsProperty.contactNumbers[0].phoneNumber
		) {
			ttHotelPhone = crsProperty.contactNumbers[0].phoneNumber
		}

		if (
			crsProperty.viewExtensions &&
			crsProperty.viewExtensions.logo
		) {
			if (crsProperty.viewExtensions.logo.dark) {
				ttHotelLogo = crsProperty.viewExtensions.logo.dark
			} else if (crsProperty.viewExtensions.logo.light) {
				ttHotelLogo = crsProperty.viewExtensions.logo.light
			}
		}
	}

	if (
		currentProperty &&
		currentProperty[0] &&
		currentProperty[0].marketingLink
	) {
		ttHotelWebsite = window.location.origin + currentProperty[0].marketingLink
	}

	const tripTeaseIdentificationData = {
		"@context": "http://schema.org",
		"@type": "Hotel",
		"name": ttHotelName,
		"identifier": ttHotelIdentifier,
		"brand": ttHotelBrand,
		"address":
			{
				"@type": "PostalAddress",
				"streetAddress": ttHotelStreetAddress,
				"addressLocality": ttHotelCity,
				"addressRegion": ttHotelRegion,
				"postalCode": ttHotelPostal,
				"addressCountry": ttHotelCountry
			},
		"telephone": ttHotelPhone,
		"image": ttHotelLogo,
		"url": ttHotelWebsite
	}

	triggerCustomGaEvent('triptease-hotel-identification', tripTeaseIdentificationData)
}


// WEBPACK FOOTER //
// ./src/utilities/tripTease/tripTeaseHotelIdentification.js